import { render } from "./LearnMoreButton.vue?vue&type=template&id=725a8212&scoped=true"
import script from "./LearnMoreButton.vue?vue&type=script&lang=js"
export * from "./LearnMoreButton.vue?vue&type=script&lang=js"

import "./LearnMoreButton.vue?vue&type=style&index=0&id=725a8212&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725a8212"]])

export default __exports__